import { useState } from 'react';
import { MapPin, Phone, Clock, Search } from 'lucide-react';
import { useSiteData, usePageContent } from '@/context/SiteDataContext';
import PageHero from '@/components/PageHero';

export default function ChurchLocator() {
  const { churches } = useSiteData();
  const c = usePageContent('locator');
  const [q, setQ] = useState('');
  const list = churches || [];
  const filtered = list.filter(c =>
    c.name?.toLowerCase().includes(q.toLowerCase()) ||
    c.address?.toLowerCase().includes(q.toLowerCase()) ||
    c.pastor?.toLowerCase().includes(q.toLowerCase())
  );

  return (
    <div>
      <PageHero slug="locator" overline="Find a Church" heading="Church Locator" text="Find a Wisconsin First COGIC congregation near you." />
      <section className="bg-white py-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="relative max-w-xl mb-10">
            <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-charcoal-muted" />
            <input data-testid="locator-search-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search by city, pastor, or church name..." className="w-full pl-12 pr-4 py-4 rounded-full border border-gray-200 focus:outline-none focus:border-royal focus:ring-2 focus:ring-royal/20" />
          </div>
          <div className="grid md:grid-cols-2 gap-8">
            <div className="space-y-4 max-h-[600px] overflow-y-auto pr-2">
              {filtered.map(c => (
                <div key={c.id} data-testid={`church-card-${c.id}`} className="card-tactile p-6">
                  <div className="font-serif text-xl text-royal font-bold">{c.name}</div>
                  <div className="text-sm text-gold mt-1">{c.pastor}</div>
                  <div className="mt-3 space-y-1 text-sm text-charcoal-muted">
                    <div className="flex items-start gap-2"><MapPin className="w-4 h-4 text-royal mt-0.5" /> {c.address}</div>
                    <div className="flex items-center gap-2"><Phone className="w-4 h-4 text-royal" /> {c.phone}</div>
                    <div className="flex items-center gap-2"><Clock className="w-4 h-4 text-royal" /> {c.services}</div>
                  </div>
                  <a href={`https://maps.google.com/?q=${encodeURIComponent(c.address || '')}`} target="_blank" rel="noreferrer" className="mt-4 inline-block text-sm text-royal font-semibold hover:text-gold">Get Directions →</a>
                </div>
              ))}
              {!filtered.length && <p className="text-charcoal-muted">No churches match your search.</p>}
            </div>
            <div className="rounded-2xl overflow-hidden shadow-xl h-[600px]">
              <iframe data-testid="google-map-iframe" width="100%" height="100%" loading="lazy" allowFullScreen referrerPolicy="no-referrer-when-downgrade"
                src="https://maps.google.com/maps?q=Milwaukee%2C+WI&z=8&output=embed" title="Church Locations Map" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
